import React, { Component } from "react";
import { Label, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import Settings from "../../settings";

class SearchHeaderTitle extends Component {
  componentDidMount() {}

  render() {
      return (
          <Label attached="top" size="medium" className="report-sub-sub-sub-section-header search-options-text">
        <Icon
          name={Settings.searchIconFromName[this.props.titleImage]}
          circular
          inverted
          color="blue"
        />
        {this.props.titleName}
      </Label>
    );
  }
}

SearchHeaderTitle.propTypes = {
  titleImage: PropTypes.string.isRequired,
  titleName: PropTypes.string.isRequired
};

export default SearchHeaderTitle;



// WEBPACK FOOTER //
// ./src/components/pages/SearchHeaderTitle.js